import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { DocumentSheet } from "@/components/DocumentSheet";
import { Printer } from "lucide-react";

const ENDPOINTS = { cotizacion: "quotes", remision: "remisiones", orden: "work-orders", factura: "invoices" };
const FILE_PREFIX = { cotizacion: "C-", remision: "remision", orden: "OT-", factura: "Factura" };
const TYPE_KEY = { cotizacion: "COT", remision: "REM", orden: "OT", factura: "FAC" };

const cleanFilePart = (s) =>
  (s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-zA-Z0-9]/g, "").toUpperCase();

const cleanPrefix = (s) =>
  (s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-zA-Z0-9-]/g, "");

const folioDigits = (number) => {
  const m = String(number || "").match(/\d+/g);
  return m ? m[m.length - 1] : cleanFilePart(number);
};

export default function DocumentoPrint() {
  const { type, id } = useParams();
  const [params] = useSearchParams();
  const hideCosts = type === "orden" || (type === "remision" && params.get("modo") === "sincostos");
  const [doc, setDoc] = useState(null);
  const [company, setCompany] = useState({ name: "TAS Publicidad 360" });
  const [prefixes, setPrefixes] = useState({});

  useEffect(() => {
    const path = ENDPOINTS[type] || "invoices";
    api.get(`/${path}/${id}`).then((r) => setDoc(r.data)).catch(() => setDoc(false));
    api.get("/settings").then((r) => {
      setCompany(r.data.company || {});
      setPrefixes(r.data.folio_prefixes || {});
    }).catch(() => {});
  }, [type, id]);

  useEffect(() => {
    document.body.style.background = "#dfe4ea";
    return () => (document.body.style.background = "");
  }, []);

  useEffect(() => {
    if (!doc) return;
    const configured = prefixes[TYPE_KEY[type]];
    const prefix = cleanPrefix(configured != null ? configured : FILE_PREFIX[type] || "");
    const clientName = doc.client?.name || doc.client_name || "";
    const fileName = `${prefix}${folioDigits(doc.number)}${cleanFilePart(clientName)}`;
    const prev = document.title;
    document.title = fileName;
    return () => { document.title = prev; };
  }, [doc, type, prefixes]);

  if (doc === null) return <div className="p-10 font-mono-data text-[#5B6672]">Cargando…</div>;
  if (doc === false) return <div className="p-10 font-mono-data text-[#ED1F26]">Documento no encontrado.</div>;

  return (
    <div className="min-h-screen py-8 flex flex-col items-center">
      <div className="no-print mb-6 flex gap-3">
        <button onClick={() => window.print()} data-testid="download-pdf-button"
          className="inline-flex items-center gap-2 bg-[#465B7F] hover:bg-[#374A66] text-white px-5 py-2.5 text-sm uppercase tracking-widest transition-colors">
          <Printer size={16} /> Descargar / Imprimir PDF
        </button>
        <button onClick={() => window.close()} className="px-5 py-2.5 text-sm uppercase tracking-widest border border-[#16202B] text-[#16202B] hover:bg-[#16202B] hover:text-white transition-colors">
          Cerrar
        </button>
      </div>

      <DocumentSheet doc={doc} company={company} type={type} hideCosts={hideCosts} variant="print" />
    </div>
  );
}
